// @core/api/endpoints/payment/list_provider_events.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListProviderEventsResponse,
} from '../../../types/payment';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/payment';

/**
 * List provider events
 * Returns incoming provider events (webhooks) with optional filtering by provider, type, and processing status.
 */
export async function ListProviderEvents(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListProviderEventsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/provider-events`;
  const requestOptions = options;
  return client.get<ListProviderEventsResponse>(requestPath, { ...requestOptions, params });
}
